import { Navigate } from 'react-router';
import { CandidateAuthService } from '../../redux/services/candidateAuth.service';

export const AuthenticatedCandidateRoute = ({ children }: any) => {
  const isLoggedIn = CandidateAuthService.getCurrentCandidate();
  if (!isLoggedIn) return <Navigate to="/error/loginCandidate" />;
  return children;
};
